/**
 * @generated SignedSource<<70c080aa79f334acbd78db556ddb63dc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type NftAuctionStatus = "CANCELED" | "ENDED" | "LIVE" | "PAUSED" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type NftPdpLiveDetailsRefetchWrapper_viewer$data = {
  readonly nftItems?: ReadonlyArray<{
    readonly mostRecentAuction: {
      readonly currentBid: {
        readonly wei: string | null;
      } | null;
      readonly status: NftAuctionStatus | null;
    } | null;
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContext_nftItem" | "NftPdpLiveDetails_nftItem">;
  } | null> | null;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContext_viewer" | "NftPdpLiveDetails_viewer">;
  readonly " $fragmentType": "NftPdpLiveDetailsRefetchWrapper_viewer";
};
export type NftPdpLiveDetailsRefetchWrapper_viewer$key = {
  readonly " $data"?: NftPdpLiveDetailsRefetchWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpLiveDetailsRefetchWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchClientDetails"
    },
    {
      "kind": "RootArgument",
      "name": "fetchSplitName"
    },
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "isDraft"
    },
    {
      "kind": "RootArgument",
      "name": "nftId"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": {
    "refetch": {
      "connection": null,
      "fragmentPathInResult": [
        "viewer"
      ],
      "operation": require('./NftPdpLiveDetailsRefetchWrapperQuery.graphql')
    }
  },
  "name": "NftPdpLiveDetailsRefetchWrapper_viewer",
  "selections": [
    {
      "condition": "fetchClientDetails",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "isDraft",
              "variableName": "isDraft"
            },
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "nftIds.0",
                  "variableName": "nftId"
                }
              ],
              "kind": "ListValue",
              "name": "nftIds"
            }
          ],
          "concreteType": "NftItem",
          "kind": "LinkedField",
          "name": "nftItems",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "serviceId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "NftAuction",
              "kind": "LinkedField",
              "name": "mostRecentAuction",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "status",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "EtherAmount",
                  "kind": "LinkedField",
                  "name": "currentBid",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "wei",
                      "storageKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NftPdpLiveDetails_nftItem"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "NftPdpBidModalContext_nftItem"
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpBidModalContext_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "NftPdpLiveDetails_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "f713a17084f88fae6f9fe2e5b3bc8d44";

export default node;
